import dayjs from 'dayjs';

export const defaultValues = {
  referenceDate: dayjs().startOf('day').toDate(),
  search: null,
  clusterId: null,
  employerId: null,
  poolId: null,
  empPoolId: null,
  brId: null
};
